import { getUrlParamsFetch } from "@/shared/utils/get-url-params";
import { urlBackend } from "@/shared/constants/networking.constants";
import { erpApi } from '@/shared/axios/erp-api';
import { NotificacionParams, NotificacionDataRes } from "@/shared/interfaces/erp/system-settings/notificacion.interface";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, put, post } = erpApi();


export const useFetchNotificacion = (enabled = false, params?: NotificacionParams) => {

  return useQuery({
    queryKey: ['notificacion', ...Object.values(params || {})],
    queryFn: async () => {
      return getNotificacion(params);
    },
    enabled,
    //refetchInterval: 60000 //cada cinco minutos
  },
  );
};

export const getNotificacion = async (params?: NotificacionParams) => {

  //const setAlert = useUiStore().setAlert;

  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<NotificacionDataRes>(
    `${urlBackend}api/v1/notificacion/?${queryParams}`,
    true
  );

  //if (resp.data.count != 0) setAlert(true, resp.data.data.at(0)?.mensaje!, AlertSeverityEnum.info)

  return resp.data;
};

export const useFetchPutNotificacion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ idNotificacion, data }: { idNotificacion: string; data: NotificacionParams }) => {
      return putNotificacion(idNotificacion, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notificacion'] });
    },
  });
};

export const putNotificacion = async (idNotificacion: string, data: NotificacionParams) => {
  const resp = put<NotificacionDataRes>(
    `${urlBackend}api/v1/notificacion/${idNotificacion}/`, data,
    true
  );
  return resp;
};

export const useFetchPostNotification = () =>{
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async(data:NotificacionParams) =>{
      return postNotificaciones(data);
    }, 
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notificacion'] });
    },
  })
}

export const postNotificaciones = async(data:NotificacionParams) =>{
  const resp = await post<NotificacionDataRes> (
    `${urlBackend}api/v1/notificacion/`,data,
    true
  );
  return resp
};
